export let data = [
  {
    disasterID: 1,
    disasterName: "Fire",
    disasterStatus: "Inactive",
    disasterDate: "06/31/2024",
    disasterType: "Industrial Fire",
    alertLevel: "Level 1",
    location: "Michigan",
  },
  {
    disasterID: 2,
    disasterName: "Flood",
    disasterStatus: "Active",
    disasterDate: "06/31/2024",
    disasterType: "Flood",
    alertLevel: "Level 3",
    location: "Arizona",
  },
  {
    disasterID: 3,
    disasterName: "Typhoon",
    disasterStatus: "Inactive",
    disasterDate: "06/31/2024",
    disasterType: "Typhoon",
    alertLevel: "Level 2",
    location: "California",
  },
  {
    disasterID: 4,
    disasterName: "Earthquake",
    disasterStatus: "Active",
    disasterDate: "06/31/2024",
    disasterType: "Earthquake",
    alertLevel: "Level 1",
    location: "Hawaii",
  },
];

export const commContacts = [
  {
    contactID: 1,
    first_name: "Chris",
    last_name: "Evans",
    occupation: "Miner",
    mobileNumber: "(555-3672-24)",
    email: "chris@mail.com",
    address1: "",
    address2: "15205 North Kierland Blvd. Suite 100.",
    city: "Scottsdale",
    state: "AZ",
    zip: "85254",
  },
  {
    contactID: 2,
    first_name: "Evans",
    last_name: "Evans",
    occupation: "Factory Worker",
    mobileNumber: "(555-3672-24)",
    email: "ev@mail.com",
    address1: "",
    address2: "15205 North Kierland Blvd. Suite 100.",
    city: "Scottsdale",
    state: "AL",
    zip: "85254",
  },
  {
    contactID: 3,
    first_name: "Lovi",
    last_name: "Evans",
    occupation: "Miner",
    mobileNumber: "(555-3672-24)",
    email: "lov@mail.com",
    address1: "",
    address2: "15205 North Kierland Blvd. Suite 100.",
    city: "Scottsdale",
    state: "AZ",
    zip: "85254",
  },
];

export let localNPC = [
  {
    npcID: 1,
    primary_county: "McCracken County",
    organization: "McCracken County West Kentucky Allied",
    primary_service_provided: "Social Services",
    mobileNumber: "(555-3672-24)",
    email: "chris@mail.com",
    address1: "",
    address2: "15205 North Kierland Blvd. Suite 100.",
    city: "Scottsdale",
    state: "AZ",
    zip: "85254",
  },
  {
    npcID: 1,
    primary_county: "McCracken County",
    organization: "United Way of Paducah/McCracken County",
    primary_service_provided: "Recovery Support Leader",
    mobileNumber: "(555-3672-24)",
    email: "chris@mail.com",
    address1: "",
    address2: "15205 North Kierland Blvd. Suite 100.",
    city: "Scottsdale",
    state: "AZ",
    zip: "85254",
  },
  {
    npcID: 1,
    primary_county: "McCracken County",
    organization: "American Red Cross",
    primary_service_provided: "Red Cross Center",
    mobileNumber: "(555-3672-24)",
    email: "chris@mail.com",
    address1: "",
    address2: "15205 North Kierland Blvd. Suite 100.",
    city: "Scottsdale",
    state: "AZ",
    zip: "85254",
  },
];

export const USStates = [
  { stateID: 1, name: "Alabama", abbreviation: "AL" },
  { stateID: 2, name: "Alaska", abbreviation: "AK" },
  { stateID: 3, name: "Arizona", abbreviation: "AZ" },
  { stateID: 4, name: "Arkansas", abbreviation: "AR" },
  { stateID: 5, name: "California", abbreviation: "CA" },
  { stateID: 6, name: "Colorado", abbreviation: "CO" },
  { stateID: 7, name: "Connecticut", abbreviation: "CT" },
  { stateID: 8, name: "Delaware", abbreviation: "DE" },
  { stateID: 9, name: "Florida", abbreviation: "FL" },
  { stateID: 10, name: "Georgia", abbreviation: "GA" },
  { stateID: 11, name: "Hawaii", abbreviation: "HI" },
  { stateID: 12, name: "Idaho", abbreviation: "ID" },
  { stateID: 13, name: "Illinois", abbreviation: "IL" },
  { stateID: 14, name: "Indiana", abbreviation: "IN" },
  { stateID: 15, name: "Iowa", abbreviation: "IA" },
  { stateID: 16, name: "Kansas", abbreviation: "KS" },
  { stateID: 17, name: "Kentucky", abbreviation: "KY" },
  { stateID: 18, name: "Louisiana", abbreviation: "LA" },
  { stateID: 19, name: "Maine", abbreviation: "ME" },
  { stateID: 20, name: "Maryland", abbreviation: "MD" },
  { stateID: 21, name: "Massachusetts", abbreviation: "MA" },
  { stateID: 22, name: "Michigan", abbreviation: "MI" },
  { stateID: 23, name: "Minnesota", abbreviation: "MN" },
  { stateID: 24, name: "Mississippi", abbreviation: "MS" },
  { stateID: 25, name: "Missouri", abbreviation: "MO" },
  { stateID: 26, name: "Montana", abbreviation: "MT" },
  { stateID: 27, name: "Nebraska", abbreviation: "NE" },
  { stateID: 28, name: "Nevada", abbreviation: "NV" },
  { stateID: 29, name: "New Hampshire", abbreviation: "NH" },
  { stateID: 30, name: "New Jersey", abbreviation: "NJ" },
  { stateID: 31, name: "New Mexico", abbreviation: "NM" },
  { stateID: 32, name: "New York", abbreviation: "NY" },
  { stateID: 33, name: "North Carolina", abbreviation: "NC" },
  { stateID: 34, name: "North Dakota", abbreviation: "ND" },
  { stateID: 35, name: "Ohio", abbreviation: "OH" },
  { stateID: 36, name: "Oklahoma", abbreviation: "OK" },
  { stateID: 37, name: "Oregon", abbreviation: "OR" },
  { stateID: 38, name: "Pennsylvania", abbreviation: "PA" },
  { stateID: 39, name: "Rhode Island", abbreviation: "RI" },
  { stateID: 40, name: "South Carolina", abbreviation: "SC" },
  { stateID: 41, name: "South Dakota", abbreviation: "SD" },
  { stateID: 42, name: "Tennessee", abbreviation: "TN" },
  { stateID: 43, name: "Texas", abbreviation: "TX" },
  { stateID: 44, name: "Utah", abbreviation: "UT" },
  { stateID: 45, name: "Vermont", abbreviation: "VT" },
  { stateID: 46, name: "Virginia", abbreviation: "VA" },
  { stateID: 47, name: "Washington", abbreviation: "WA" },
  { stateID: 48, name: "West Virginia", abbreviation: "WV" },
  { stateID: 49, name: "Wisconsin", abbreviation: "WI" },
  { stateID: 50, name: "Wyoming", abbreviation: "WY" },
];

export const Counties = [
  "Los Angeles",
  "Cook",
  "Harris",
  "Maricopa",
  "San Diego",
  "Orange",
  "Miami-Dade",
  "Dallas",
  "King",
  "Clark",
];

export const countries = [
  {
    countryId: "1",
    name: "United States",
    abbreviation: "US",
  },
  {
    countryId: "2",
    name: "United Kingdom",
    abbreviation: "UK",
  },
  {
    countryId: "3",
    name: "Canada",
    abbreviation: "CA",
  },
  {
    countryId: "4",
    name: "Mexico",
    abbreviation: "MX",
  },
];

export let householdMembers = [
  {
    householdMemberID: 1,
    firstName: "John",
    lastName: "Doe",
    dateOfBirth: "08/05/1996",
    relationship: "Husband",
    disability: "None",
  },
  {
    householdMemberID: 2,
    firstName: "Jane",
    lastName: "Doe",
    dateOfBirth: "12/12/1996",
    relationship: "Wife",
    disability: "Deaf",
  },
  {
    householdMemberID: 3,
    firstName: "Oliver",
    lastName: "Davis",
    dateOfBirth: "01/01/1990",
    relationship: "Kabit",
    disability: "Visually Impaired",
  },
];

export let pets = [
  {
    petID: 1,
    petName: "Snowball",
    petBreed: "Golden Retriever",
    petColor: "Golden",
    petAge: "5",
    petSize: "Large",
  },
  {
    petID: 2,
    petName: "Luna",
    petBreed: "Persian",
    petColor: "White",
    petAge: "3",
    petSize: "Small",
  },
  {
    petID: 3,
    petName: "Bubbles",
    petBreed: "Parrot",
    petColor: "Green",
    petSize: "Small",
  },
];

export const surveyQuestions = [
  {
    section: "General Survey Questions",
    questions: [
      {
        question: "Was the impacted address your primary address?",
        type: "radio",
        options: ["Yes", "No", "N/A"],
      },
      {
        question: "Have you applied for FEMA assistance, if available?",
        type: "radio",
        options: ["Yes", "No", "N/A"],
      },
      {
        question: "CATEGORIES of IMPACT (select all that apply)",
        type: "checkbox",
        options: [
          "I suffered physical injury directly caused as the result of the disaster or developed severe mental health issues.",
          "I was displaced from my primary residence as the result of a disaster.",
          "I suffered substantial or complete loss or damage to my primary residence due to the disaster.",
          "I suffered the loss of household income directly related to the disaster.",
          "I am grieving over the death of a loved one.",
          "I am / was an emergency response or relief worker.",
          "I resided in a mandatory evacuation zone.",
          "N/A",
        ],
      },
      {
        question: "What is your current living situation?",
        type: "radio",
        options: [
          "I am safely living inside my home.",
          "I am unsafely living inside my home.",
          "I am displaced with at the residence of a relative or friend.",
          "I am displaced at a hotel or other form of temporary housing or shelter.",
          "I am unsheltered.",
          "N/A",
        ],
      },
      // {
      //   question: "Was the impacted property your primary residence?",
      //   type: "radio",
      //   options: [
      //     "Yes",
      //     "The impacted home was a second residence.",
      //     "The impacted home was an investment property.",
      //     "Rent",
      //     "Own",
      //     "Rent To Own",
      //   ],
      // },
      // {
      //   question: "Do you have insurance on your home or contents?",
      //   type: "checkbox",
      //   options: [
      //     "Homeowner's insurance",
      //     "Flood insurance",
      //     "Renter's insurance",
      //     "Earthquake additional coverage",
      //     "Other disaster related additional coverage",
      //     "I did not have insurance",
      //   ],
      // },
      // {
      //   question: "What type of structure is the impacted home?",
      //   type: "radio",
      //   options: [
      //     "Single family dwelling",
      //     "Mobile or manufactured",
      //     "Condo",
      //     "Other",
      //   ],
      // },
      {
        // question: "What is the size of the impacted home?",
        question: "Approximately how large is the impacted home?",
        type: "radio",
        options: [
          "Under 1,000 square feet",
          "1,001-1,500 square feet",
          "1,501-2,500 square feet",
          "2,501-3,500 square feet",
          "Greater than 3,500 square feet",
          "N/A",
        ],
      },
      {
        question: "How old is the impacted home?",
        type: "radio",
        options: [
          "Under 10 years old",
          "11-25 years old",
          "26-50 years old",
          "Over 50 years old",
          "N/A",
        ],
      },
      {
        // question: "Which of the following describes to the impacted home?",
        question:
          "What type of foundation or substructure does the impacted home have?",
        type: "radio",
        options: [
          "The home has a basement.",
          "The home has a crawl space.",
          "The home DOES NOT have a basement or a crawl space.",
          "Electrical, plumbing, or HVAC ductwork run underneath the home.",
          "N/A",
        ],
      },
      // {
      //   question: "The impacted home:",
      //   type: "radio",
      //   options: ["Is destroyed", "Has major damage", "Has minor damage"],
      // },
      {
        // question: "What level of damage did your home sustain?",
        question: "How would you describe the level of damage to your home?",
        type: "radio",
        options: [
          "No Damage",
          "Slight Damage",
          "Moderate Damage",
          "Severe Damage",
          "Total Destruction",
          "N/A",
        ],
      },
      {
        question: "Does the impacted home have running water?",
        type: "radio",
        options: [
          "Yes, the well or public water connection is working",
          "No, public water connection is NOT working",
          "No, the well is NOT working",
          "N/A",
        ],
      },
      {
        question: "Do you have well water?",
        type: "radio",
        options: ["Yes", "No", "N/A"],
      },
      {
        question: "Does the impacted home have working electric or gas?",
        type: "checkbox",
        options: [
          "Check All",
          "Yes, the home has working electric.",
          "Yes, the home has working natural gas.",
          "Yes, the home has working propane.",
          "No, the home does not have working electric.",
          "No, the home does not have working natural gas.",
          "No, the home does not have working propane.",
          "N/A",
        ],
      },
      // {
      //   question: "Is there water damage inside of the impacted home?",
      //   type: "radio",
      //   options: [
      //     "Yes, there was standing water greater than 12 inches in the home.",
      //     "Yes, there was standing water less than 12 inches in the home.",
      //     "Yes, the interior and contents took on water from rain or busted pipes.",
      //     "No, water did not come inside the home.",
      //   ],
      // },
      {
        // question: "There is visible damage to the home's:",
        question: "What parts of the property had damage?",
        type: "checkbox",
        options: [
          "Check All",
          "Siding",
          "Flooring",
          "Cabinets",
          "Shed",
          "Roof",
          "Foundation",
          "Floor Joists",
          "HVAC",
          "Driveway",
          "Gutters",
          "Ceiling",
          "Drywall",
          "Electrical",
          "Yard/Uprooted trees",
          "Basement",
          "Attached Garage",
          "Detached Garage",
          "Carport",
          "Other",
          "N/A",
        ],
      },
      {
        // question: "What level of injury did you sustain?",
        question:
          "What is the worst level of injury sustained by a member of your household?",
        type: "radio",
        options: [
          "No Injury",
          "Minor Injury",
          "Sought Medical Treatment",
          "Visited Hospital",
          "Admitted",
          "N/A",
        ],
      },
      {
        // question: "Was your vehicle impacted?",
        question: "Did the disaster cause damage to your vehicle?",
        type: "radio",
        options: [
          "Yes, my vehicle sustained major damage.",
          "Yes, my vehicle's windows were damaged",
          "No, my vehicle was not impacted",
          "N/A",
        ],
      },
      {
        question: "How many vehicles were impacted?",
        type: "text",
        placeholder: "e.g. 1",
      },
      // {
      //   question:
      //     "What type of insurance did you have on the impacted vehicle(s)?",
      //   type: "radio",
      //   options: [
      //     "Liability only",
      //     "Full coverage",
      //     "I did not have automobile insurance",
      //   ],
      // },
      {
        question:
          "Do you need assistance with removal of hazardous materials from your property?",
        type: "radio",
        options: ["Yes", "No", "N/A"],
      },
      {
        question: "Do you need immediate assistance with debris removal?",
        type: "radio",
        options: ["Yes", "No", "N/A"],
      },
      // {
      //   question: "Do you need immediate assistance tarping your roof?",
      //   type: "radio",
      //   options: ["Yes", "No"],
      // },
      // {
      //   question: "Do you need immediate assistance with boarding windows?",
      //   type: "radio",
      //   options: ["Yes", "No"],
      // },
      // {
      //   question: "Do you need immediate assistance with heat or cooling?",
      //   type: "radio",
      //   options: ["Yes", "No"],
      // },
      // {
      //   question: "Do you need immediate supplies such as food and water?",
      //   type: "radio",
      //   options: ["Yes", "No"],
      // },
      {
        question: "Do you have access to reliable transportation?",
        type: "radio",
        options: ["Yes", "No", "N/A"],
      },
      {
        question:
          "Do you or anyone in your household have mobility or medical equipment that requires electricity?",
        type: "radio",
        options: [
          "Yes, and I currently have electricity.",
          "Yes, and I currently do not have electricity.",
          "No.",
          "N/A",
        ],
      },
      {
        question: "IMMEDIATE NEEDS Check all that apply",
        type: "checkbox",
        options: [
          "Check All",
          "Food / nutrition",
          "Employment/Job training",
          "Utilities (shut-off or pending shut-off)",
          "Medical health care",
          "Transportation",
          "Furniture, appliances",
          "Medication",
          "Child care",
          "Clothing",
          "Counseling",
          "Financial Assistance",
          "Resource Information",
          "Personal Hygiene",
          "Medical Equipment",
          "Volunteer Support (labor/debris)",
          "Home repair",
          "Eviction",
          "Water",
          "Mold Remediation",
          "Temporary Housing",
          "Other",
          "N/A",
        ],
      },
    ],
  },
];

export const fireQuestions = [
  // {
  //   section: "Personal and Household Information",
  //   questions: [
  //     {
  //       question: "Full Name",
  //       type: "text",
  //       options: ["Enter your full name"],
  //       placeholder: "John Doe"
  //     },
  //     {
  //       question: "Address",
  //       type: "text",
  //       options: ["Enter your address"],
  //       placeholder: "123 Main St, City, State, ZIP"
  //     },
  //     {
  //       question: "Phone Number",
  //       type: "text",
  //       options: ["Enter your phone number"],
  //       placeholder: "(555) 555-5555"
  //     },
  //     {
  //       question: "Number of Household Members",
  //       type: "text",
  //       options: ["Enter number"],
  //       placeholder: "e.g., 4"
  //     },
  //     {
  //       question: "Are there children, elderly, or individuals with disabilities in the household?",
  //       type: "radio",
  //       options: ["Yes", "No"],
  //       followUp: {
  //         condition: "Yes",
  //         question: "Please specify details about household members",
  //         type: "text",
  //         placeholder: "e.g., 2 children under 10, 1 elderly person, 1 person with mobility disability"
  //       }
  //     }
  //   ]
  // },
  {
    section: "Section 1: Immediate Safety and Health Concerns",
    questions: [
      {
        question:
          "Is everyone in your household currently safe and accounted for?",
        type: "radio",
        options: ["Yes", "No", "N/A"],
        followUp: {
          condition: "No",
          question: "If no, please specify who is missing or injured:",
          type: "text",
          placeholder: "Enter details here",
        },
      },
      {
        question:
          "Has anyone in your household experienced injuries (burns, smoke inhalation, etc.)?",
        type: "radio",
        options: ["Yes", "No", "N/A"],
        followUp: {
          condition: "Yes",
          question: "If yes, please describe the nature of the injuries:",
          type: "text",
          placeholder: "Enter injury details",
        },
      },
      {
        question:
          "Do you or anyone in your household require urgent medical attention?",
        type: "radio",
        options: ["Yes", "No", "N/A"],
        followUp: {
          condition: "Yes",
          question: "If yes, what kind of medical assistance is needed?",
          type: "text",
          placeholder: "Describe medical assistance needed",
        },
      },
      {
        question:
          "Is your home or immediate area still under threat from fire or smoke?",
        type: "radio",
        options: ["Yes", "No", "Unsure", "N/A"],
      },
      {
        question:
          "Do you have access to clean water and food for the next 24 hours?",
        type: "radio",
        options: ["Yes", "No", "N/A"],
      },
    ],
  },
  {
    section: "Section 2: Housing and Shelter Needs",
    questions: [
      {
        question: "Is your home habitable?",
        type: "radio",
        options: ["Yes", "No", "N/A"],
        followUp: {
          condition: "No",
          question: "If no, please describe the extent of damage:",
          type: "text",
          placeholder: "Enter damage details",
        },
      },
      {
        question: "Do you currently have access to temporary shelter?",
        type: "radio",
        options: [
          "Yes (Staying with family, friends, shelter, etc.)",
          "No",
          "N/A",
        ],
        followUp: {
          condition: "No",
          question: "If no, do you need emergency shelter assistance?",
          type: "radio",
          options: ["Yes", "No", "N/A"],
        },
      },
      {
        question: "If you are currently in a shelter, how long can you stay?",
        type: "radio",
        options: [
          "1 day or less",
          "2-3 days",
          "1 week or more",
          "No shelter available",
          "N/A",
        ],
      },
    ],
  },
  {
    section: "Section 3: Access to Utilities and Essential Services",
    questions: [
      {
        question:
          "Do you have access to power, heating/cooling, and basic utilities in your home or temporary shelter?",
        type: "radio",
        options: ["Yes", "No", "N/A"],
      },
      {
        question:
          "Do you have access to essential services (e.g., hospital, pharmacy, fire station)?",
        type: "radio",
        options: ["Yes", "No", "N/A"],
      },
      {
        question:
          "Have you lost important personal documentation (e.g., ID, insurance papers, medical records)?",
        type: "radio",
        options: ["Yes", "No", "N/A"],
        followUp: {
          condition: "Yes",
          question: "If yes, please specify:",
          type: "text",
          placeholder: "Enter lost documentation details",
        },
      },
    ],
  },
  {
    section: "Section 4: Financial and Recovery Resources",
    questions: [
      {
        question:
          "Do you have insurance coverage for fire damage to your home or personal belongings?",
        type: "radio",
        options: ["Yes", "No", "Unsure", "N/A"],
      },
      {
        question:
          "Are you currently in need of financial assistance for recovery?",
        type: "radio",
        options: ["Yes", "No", "N/A"],
      },
      {
        question:
          "Have you applied for or received any assistance from local or federal agencies (FEMA, Red Cross, etc.)?",
        type: "radio",
        options: ["Yes", "No", "N/A"],
      },
      {
        question:
          "Do you have transportation to access food, supplies, or medical services?",
        type: "radio",
        options: ["Yes", "No", "N/A"],
      },
    ],
  },
  {
    section: "Section 5: Emotional and Psychological Well-being",
    questions: [
      {
        question:
          "Is anyone in your household currently experiencing significant emotional distress or trauma?",
        type: "radio",
        options: ["Yes", "No", "N/A"],
        followUp: {
          condition: "Yes",
          question: "If yes, would you like assistance or counseling services?",
          type: "radio",
          options: ["Yes", "No", "N/A"],
        },
      },
    ],
  },
  {
    section: "Section 6: Additional Concerns and Needs",
    questions: [
      {
        question:
          "Are there any other immediate concerns or needs you would like to share?",
        type: "radio",
        options: ["Yes", "No", "N/A"],
        followUp: {
          condition: "Yes",
          question: "If yes, please specify:",
          type: "text",
          placeholder: "Enter your concerns or needs",
        },
      },
    ],
  },
  {
    section: "Section 7: Wildfire-Specific Questions",
    questions: [
      {
        question:
          "Was your home directly affected by the wildfire (burned, scorched, or structurally damaged)?",
        type: "radio",
        options: ["Yes", "No", "N/A"],
      },
      {
        question:
          "Did embers or firebrands cause damage to your home or property?",
        type: "radio",
        options: ["Yes", "No", "N/A"],
      },
      {
        question: "Did your home suffer smoke damage?",
        type: "radio",
        options: [
          "Yes, minor smoke exposure inside the home",
          "Yes, major smoke exposure inside the home",
          "No",
          "N/A",
        ],
      },
      {
        question: "Did the wildfire damage external property structures?",
        type: "checkbox",
        options: [
          "Garage/Shed",
          "Fence",
          "Outdoor Equipment",
          "Trees/Landscape",
          "Other",
          "N/A",
        ],
      },
      {
        question: "Did you have to evacuate due to the wildfire?",
        type: "radio",
        options: [
          "Yes, I evacuated before the fire reached my area",
          "Yes, I was forced to evacuate due to an emergency order",
          "No, I stayed in place",
          "N/A",
        ],
      },
      {
        question:
          "Were you able to take all household members and pets with you when evacuating?",
        type: "radio",
        options: [
          "Yes",
          "No, I had to leave pets behind",
          "No, I had to leave household members behind",
          "N/A",
        ],
      },
      {
        question: "Where did you evacuate to?",
        type: "radio",
        options: [
          "Shelter or evacuation center",
          "Hotel or rental property",
          "Stayed with friends/family",
          "Vehicle or temporary outdoor shelter",
          "Other",
          "N/A",
        ],
      },
      {
        question: "Do you currently have a safe place to stay?",
        type: "radio",
        options: ["Yes", "No", "N/A"],
      },
      {
        question:
          "Have you or anyone in your household experienced wildfire smoke-related health effects?",
        type: "checkbox",
        options: [
          "Difficulty breathing/asthma flare-ups",
          "Eye irritation/burning sensation",
          "Severe coughing or sore throat",
          "Headaches/dizziness",
          "Skin irritation/rash",
          "Other",
          "N/A",
        ],
      },
      {
        question: "Do you need air filtration or masks due to smoke exposure?",
        type: "radio",
        options: ["Yes", "No", "N/A"],
      },
      {
        question: "Did the wildfire impact roads leading to or from your home?",
        type: "radio",
        options: [
          "Yes, roads are blocked or damaged",
          "No, roads are accessible",
          "N/A",
        ],
      },
      {
        question: "Is your home currently accessible?",
        type: "radio",
        options: [
          "Yes",
          "No, restricted by authorities",
          "No, unsafe due to damage",
          "N/A",
        ],
      },
      {
        question:
          "Do you need assistance recovering livestock or large animals left behind?",
        type: "radio",
        options: ["Yes", "No", "N/A"],
      },
    ],
  },
];

export const tornadoQuestions = [
  {
    section: "Tornado Questions",
    questions: [
      {
        question:
          "Did the tornado remove the roof or damage the walls of your home? (Select  all that apply)",
        type: "checkbox",
        options: [
          "Check All",
          "Yes, the entire roof is gone",
          "Yes, part of the roof is missing or damaged",
          "Yes, the walls are damaged or collapsed",
          "No, the roof and walls are intact",
          "N/A",
        ],
      },
      {
        question:
          "Was your home hit by debris or a fallen tree? (Select all that apply)",
        type: "checkbox",
        options: [
          "Check All",
          "Yes, debris caused damage",
          "Yes, a tree fell on my home",
          "Access to the home is restricted by debris",
          "No",
          "N/A",
        ],
      },
      {
        question: "Did you have to take shelter during the tornado?",
        type: "radio",
        options: [
          "Yes, in my home",
          "Yes, in my storm shelter",
          "Yes, in my basement",
          "Yes, at a friend or family members",
          "Yes, in a public storm shelter",
          "No, I did not take shelter",
          "N/A",
        ],
      },
      {
        question:
          "Were you or anyone in your household trapped in debris after the tornado?",
        type: "radio",
        options: ["Yes", "No", "N/A"],
      },
      {
        question:
          "Are you experiencing any respiratory issues due to dust and debris in the air?",
        type: "radio",
        options: ["Yes", "No", "N/A"],
      },
      {
        question:
          "Are roads leading to or from your home blocked by tornado debris?",
        type: "radio",
        options: ["Yes", "No", "N/A"],
      },
    ],
  },
];

export const floodQuestions = [
  {
    section: "Flood Questions",
    questions: [
      {
        question: "Was the impacted home in a known flood zone?",
        type: "radio",
        options: ["Yes", "No", "N/A"],
      },
      {
        question: "What is the estimated depth of water that entered the home?",
        type: "radio",
        options: [
          "No water entered the home",
          "Less than 1 inch (e.g., damp floor, minor seepage)",
          "1 to 6 inches (e.g., shallow flooding on floor level)",
          "7 to 17 inches (e.g., above floorboards, lower wall damage)",
          "18 to 24 inches (e.g., electrical outlets impacted, significant damage possible)",
          "More than 24 inches / 2 feet (e.g., major structural damage possible)",
          "Water reached ceiling or higher floor(s)",
          "N/A",
        ],
      },
      {
        question: "Did water reach electrical outlets?",
        type: "radio",
        options: ["Yes", "No", "N/A"],
      },
      {
        question: "Is there standing water still inside the home?",
        type: "radio",
        options: [
          "Yes in the basement",
          "Yes in the crawlspace",
          "Yes on the 1st floor",
          "No",
          "N/A",
        ],
      },
      {
        question: "Is there standing water on the outside of the home?",
        type: "radio",
        options: ["Yes", "No", "N/A"],
      },
      {
        question:
          "Is there visible mold growth inside the home due to flood exposure?",
        type: "radio",
        options: ["Yes", "No", "N/A"],
      },
      {
        question:
          "Are there any individuals with respiratory issues or compromised health at risk due to mold exposure?",
        type: "radio",
        options: ["Yes", "No", "N/A"],
      },
      {
        question:
          "Have major appliances been affected by flooding? (Select all that apply)",
        type: "checkbox",
        options: [
          "Check All",
          "Refrigerator/Freezer",
          "Washing Machine",
          "Electric Dryer",
          "Gas Dryer",
          "Dishwasher",
          "Water Heater",
          "Air Conditioner (Window units or central systems)",
          "Electric Furnace",
          "Gas Furnace",
          "Electric Stove/Oven",
          "Gas Stove/Oven",
          "Microwave",
          "Dehumidifier",
          "Sump Pump",
          "Garbage Disposal",
          "Water Filtration Systems",
          "Chest Freezer",
          "N/A",
        ],
      },
      {
        question:
          "Do you need general flood cleanup supplies? (Select all that apply)",
        type: "checkbox",
        options: [
          "Check All",
          "Rakes",
          "Shovels",
          "Muck & Gut",
          "Fan",
          "Sump pump",
          "Dehumidifier",
          "Protective Equipment (Gloves, Masks)",
          "Other",
          "N/A",
        ],
      },
    ],
  },
];

export const hurricaneQuestions = [
  {
    section: "Hurricane Questions",
    questions: [
      {
        question:
          "Was your home impacted by hurricane-force winds or storm surge?",
        type: "radio",
        options: [
          "hurricane-force winds",
          "storm surge",
          "both",
          "neither",
          "N/A",
        ],
      },
      {
        question:
          "Have you observed flooding inside your home due to storm surge or heavy rainfall?",
        type: "radio",
        options: ["Yes", "No", "N/A"],
      },
      {
        question: "What is the estimated depth of water that entered the home?",
        type: "radio",
        options: [
          "No water entered the home",
          "Less than 1 inch (e.g., damp floor, minor seepage)",
          "1 to 6 inches (e.g., shallow flooding on floor level)",
          "7 to 17 inches (e.g., above floorboards, lower wall damage)",
          "18 to 24 inches (e.g., electrical outlets impacted, significant damage possible)",
          "More than 24 inches / 2 feet (e.g., major structural damage possible)",
          "Water reached ceiling or higher floor(s)",
          "N/A",
        ],
      },
      {
        question: "Did you evacuate before the hurricane made landfall?",
        type: "radio",
        options: ["Yes", "No", "N/A"],
      },
      {
        question: "If evacuated, have you been able to return home safely?",
        type: "radio",
        options: ["Yes", "No", "N/A"],
      },
      {
        question: "Are roadways in your area blocked by debris or floodwaters?",
        type: "radio",
        options: ["Yes", "No", "N/A"],
      },
      {
        question:
          "Are you experiencing respiratory issues due to mold or water damage inside the home?",
        type: "radio",
        options: ["Yes", "No", "N/A"],
      },
    ],
  },
];

export const pastRecoveryPlan = [
  {
    categoryID: 1,
    category: "General devris removal",
    subCategory: "General",
    descOfDamage: "House burned down",
    photoAttachment: "Burned House",
    estimateToRepair: "$12.00",
    donated: "House",
    valueOfDonated: "$500.00",
    otherSource: "Insurance",
    amountOfFunding: "$12.00",
    fundingGap: "$12.00",
  },
  {
    categoryID: 2,
    category: "General devris removal",
    subCategory: "Design and Planning",
    descOfDamage: "House burned down",
    photoAttachment: "Burned House",
    estimateToRepair: "$12.00",
    donated: "House",
    valueOfDonated: "$500.00",
    otherSource: "Insurance",
    amountOfFunding: "$12.00",
    fundingGap: "$12.00",
  },
  {
    categoryID: 3,
    category: "General devris removal",
    subCategory: "Design and Planning",
    descOfDamage: "House burned down",
    photoAttachment: "Burned House",
    estimateToRepair: "$12.00",
    donated: "House",
    valueOfDonated: "$500.00",
    otherSource: "Insurance",
    amountOfFunding: "$12.00",
    fundingGap: "$12.00",
  },
  {
    categoryID: 4,
    category: "General devris removal",
    subCategory: "Design and Planning",
    descOfDamage: "House burned down",
    photoAttachment: "Burned House",
    estimateToRepair: "$12.00",
    donated: "House",
    valueOfDonated: "$500.00",
    otherSource: "Insurance",
    amountOfFunding: "$12.00",
    fundingGap: "$12.00",
  },
  {
    categoryID: 5,
    category: "General devris removal",
    subCategory: "Design and Planning",
    descOfDamage: "House burned down",
    photoAttachment: "Burned House",
    estimateToRepair: "$12.00",
    donated: "House",
    valueOfDonated: "$500.00",
    otherSource: "Insurance",
    amountOfFunding: "$12.00",
    fundingGap: "$12.00",
  },
  {
    categoryID: 6,
    category: "Tree Removal",
    subCategory: "Design and Planning",
    descOfDamage: "House burned down",
    photoAttachment: "Burned House",
    estimateToRepair: "$12.00",
    donated: "House",
    valueOfDonated: "$500.00",
    otherSource: "Insurance",
    amountOfFunding: "$12.00",
    fundingGap: "$12.00",
  },
  {
    categoryID: 7,
    category: "Tree Removal",
    subCategory: "Design and Planning",
    descOfDamage: "House burned down",
    photoAttachment: "Burned House",
    estimateToRepair: "$12.00",
    donated: "House",
    valueOfDonated: "$500.00",
    otherSource: "Insurance",
    amountOfFunding: "$12.00",
    fundingGap: "$12.00",
  },
  {
    categoryID: 8,
    category: "Tree Removal",
    subCategory: "Design and Planning",
    descOfDamage: "House burned down",
    photoAttachment: "Burned House",
    estimateToRepair: "$12.00",
    donated: "House",
    valueOfDonated: "$500.00",
    otherSource: "Insurance",
    amountOfFunding: "$12.00",
    fundingGap: "$12.00",
  },
  {
    categoryID: 9,
    category: "Tree Removal",
    subCategory: "Design and Planning",
    descOfDamage: "House burned down",
    photoAttachment: "Burned House",
    estimateToRepair: "$12.00",
    donated: "House",
    valueOfDonated: "$500.00",
    otherSource: "Insurance",
    amountOfFunding: "$12.00",
    fundingGap: "$12.00",
  },
  {
    categoryID: 10,
    category: "Tree Removal",
    subCategory: "Design and Planning",
    descOfDamage: "House burned down",
    photoAttachment: "Burned House",
    estimateToRepair: "$12.00",
    donated: "House",
    valueOfDonated: "$500.00",
    otherSource: "Insurance",
    amountOfFunding: "$12.00",
    fundingGap: "$12.00",
  },
  {
    categoryID: 11,
    category: "Tree Removal",
    subCategory: "Design and Planning",
    descOfDamage: "House burned down",
    photoAttachment: "Burned House",
    estimateToRepair: "$12.00",
    donated: "House",
    valueOfDonated: "$500.00",
    otherSource: "Insurance",
    amountOfFunding: "$12.00",
    fundingGap: "$12.00",
  },
];

export const disasterContacts = [
  {
    contactID: 1,
    name: "Chris",
    occupation: "Miner",
    organization: "Construction",
    mobile: "(555-3672-24)",
    email: "chris@mail.com",
    notes: "",
    action: "",
  },
  {
    contactID: 2,
    name: "Jane",
    occupation: "Miner",
    organization: "Construction",
    mobile: "(555-3672-24)",
    email: "jane@mail.com",
    notes: "",
    action: "",
  },
];

export const closingSections = [
  {
    title: "Immediate Needs",
    questions: [
      { key: "food", text: "Do you need food?" },
      { key: "clothing", text: "Do you need clothing?" },
      { key: "shelter", text: "Do you need shelter?" },
      { key: "medical", text: "Do you need medical assistance?" },
      { key: "transportation", text: "Do you need transportation?" },
      { key: "utilities", text: "Do you need help with utilities?" },
      { key: "water", text: "Do you need clean water?" },
      { key: "medication", text: "Do you need medication?" },
      {
        key: "personal_hygiene",
        text: "Do you need personal hygiene items?",
      },
      { key: "childcare", text: "Do you need childcare assistance?" },
      { key: "financial", text: "Do you need financial assistance?" },
      {
        key: "counseling",
        text: "Do you need counseling or mental health support?",
      },
      {
        key: "employment",
        text: "Do you need employment or job training assistance?",
      },
      { key: "furniture", text: "Do you need furniture or appliances?" },
      { key: "home_repair", text: "Do you need home repair assistance?" },
      {
        key: "debris_removal",
        text: "Do you need debris removal assistance?",
      },
    ],
  },
  {
    title: "Personal Property",
    questions: [
      { key: "pp_furniture", text: "Do you need furniture?" },
      { key: "pp_appliances", text: "Do you need appliances?" },
      { key: "pp_vehicle", text: "Do you need vehicle assistance?" },
    ],
  },
  {
    title: "Housing & Construction",
    questions: [
      { key: "hc_temporary_housing", text: "Do you need temporary housing?" },
      { key: "hc_relocation", text: "Do you need relocation assistance?" },
      { key: "hc_repair", text: "Do you need repair assistance?" },
      { key: "hc_rebuild", text: "Do you need rebuild assistance?" },
      { key: "hc_replacement", text: "Do you need replacement assistance?" },
      { key: "hc_demolition", text: "Do you need demolition assistance?" },
      { key: "hc_elevation", text: "Do you need elevation assistance?" },
      { key: "hc_household_storage", text: "Do you need household storage?" },
      { key: "hc_mold_remediation", text: "Do you need mold remediation?" },
      {
        key: "hc_moving_expenses",
        text: "Do you need moving/relocation expenses assistance?",
      },
    ],
  },
  {
    title: "Service & Referrals",
    questions: [
      {
        key: "sr_access_functional",
        text: "Do you need access functional needs assistance?",
      },
      {
        key: "sr_employment_training",
        text: "Do you need employment/job training?",
      },
      {
        key: "sr_childcare_youth",
        text: "Do you need child care / youth services?",
      },
      { key: "sr_pet_assistance", text: "Do you need pet assistance?" },
      {
        key: "sr_medical_healthcare",
        text: "Do you need medical health care?",
      },
      { key: "sr_medication", text: "Do you need medication?" },
      {
        key: "sr_mental_health",
        text: "Do you need mental health services?",
      },
      {
        key: "sr_emotional_spiritual",
        text: "Do you need emotional & spiritual care?",
      },
      { key: "sr_transportation", text: "Do you need transportation?" },
      {
        key: "sr_utilities_shutoff",
        text: "Do you need utilities (shut-off or pending shut-off) assistance?",
      },
      { key: "sr_medical_equipment", text: "Do you need medical equipment?" },
    ],
  },
  {
    title: "Advocacy",
    questions: [
      { key: "adv_fema", text: "Do you need FEMA advocacy?" },
      { key: "adv_insurance", text: "Do you need insurance advocacy?" },
      { key: "adv_legal", text: "Do you need legal assistance?" },
      { key: "adv_sba", text: "Do you need SBA advocacy?" },
      {
        key: "adv_substantial_damage",
        text: "Do you need substantial damage advocacy?",
      },
    ],
  },
];
